import e from "@appfolio/mobile-app-detector";
import t from "eventemitter3";
var a,
    n = new e({
  userAgent: navigator.userAgent
});
n.usingMobileApp && document.documentElement.classList.add("is-in-mobile-app"), function (e) {
  e.NativeUpload = "a", e.PostMessage = "b", e.NativeNavigation = "c";
}(a || (a = {}));

var i = new t(),
    o = function () {
  function e() {}

  var t = e.prototype;
  return t.onAppEvent = function (e, t) {
    i.on(e, t);
  }, t.sendEvent = function (e, t) {
    var i = {
      type: e.toUpperCase()
    };
    if (t && (i.payload = t), !n.hasCapability(a.PostMessage) || !window.ReactNativeWebView) throw new Error("sendEvent can only be called when the client is the mobile app");
    window.ReactNativeWebView.postMessage(JSON.stringify(i));
  }, e;
}();

window.addEventListener("click", function (e) {
  var t = e.target;

  if (null != t && t.matches(".js-mobile-app-event") && t.dataset.eventType) {
    e.preventDefault();
    var a = t.dataset.eventPayload || "{}";

    try {
      a = JSON.parse(a);
    } catch (e) {
      console.error("Error parsing JSON payload from js-mobile-app-event link", t);
    }

    r.sendEvent(t.dataset.eventType, a);
  }
}), window.addEventListener("message", function (e) {
  if ("" === e.origin) {
    var t = JSON.parse(e.data);
    i.emit(t.type, t.payload);
  }
});
var r = new o();
export { a as Capability, r as Communicator, n as Detector };